export const ValidateMessages = {
    REQUIRED: (fieldName) => `${fieldName} is required`,
    SELECTED: (fieldName) => `Please select ${fieldName.toLowerCase()}`,
    NOT_VALID: (fieldName) => `${fieldName} not valid`,
    UPLOAD_LOGO: (fieldName) => `Please upload ${fieldName.toLowerCase()} logo`,
    BLANK_SPACE:(fieldName)=> ` ${fieldName} must not be a blank space`,
    SHOULD_STRING: (fieldName)=> `${fieldName} should be string`,
    ONLY_TEXT: (fieldName) => `Enter only text in the ${fieldName}`, 
    VALID:(fieldName)=>`Please enter valid ${fieldName}`,
    SHOULD_SAME_FIELD_NAME: (fieldName) => `Should not be same ${fieldName} to the same country`,
    SHOULD_MAX_LETTER: (fieldName, max) => `${fieldName} should be maximum ${max} letters`,
    SHOULD_MIN_LETTER: (fieldName, min) => `${fieldName} should be minimum ${min} letters`,
    FILE_SIZE: (fieldName, max) =>  `${fieldName} size is greater than max limit of ${max}kb`,
    MAX_LENGTH: (max) => `Maximum Length should be ${max}`,
    MIN_LENGTH: (min) => `Name must have minimum length of ${min}`,
    PASSWORD_LONG: (num)=> `Password must be at least ${num} characters long`,
    CONVERSATION_RATE: "Please enter conversion rate",
    NOT_ALLOWED: "Negative values/text/zero/more than two demical palces not allowed",
    SELECT_DUE_DATE: "Select due date",
    TRANSPORT_MODE:"At least one transport mode is required",
    ALREADY_EXISTS: "Contact with the same email or phone number already exists",
    DIGITS_ALLOWED: "Only digits allowed",
    POSITIVE_NUMBER_ALLOWED: "Please enter greater than zero",
    CONTACT_AVAILABLE: "Contacts available in the same phone and email",
    GREATER_START_DATE: "End date should be greater than start date",
    PASSWORD_NOT_MATCH: "Passwords do not match",
    TEXT_CONTACT_NAME: "Enter only text in the contact name",
    EMAIL_ALREADY_EXISTS: "Email id is already exists",
    SELECTED_ATLEAST_ONE:"Please select at least one option",
    FORECAST_QUANTITY:"Forecast quantity should be equal or less than the quotation quantity.",
    FORECAST_AMOUNT:"Forecast amount should be equal or less than the quotation amount.",
    CHECK_ROLE:"Please select any one role",
    FORECAST_REQUIRED:"Please add the forecast",
    FORECAST_MISMATCH:"The quotation mark has been revised. Please update the quantity and amount accordingly.",
    PASSWORD_RESTRICTION:"Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character ",
  };


 

  
